import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '电影', path: '/category/movies' },
  { label: '电视剧', path: '/category/tv-series' },
  { label: '动漫', path: '/category/anime' },
  { label: '综艺', path: '/category/variety' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md border-b border-background-700/30'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-50 tracking-wide">
              夜猫电影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-800/50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-400 hover:text-foreground-100 hover:bg-background-800/50 transition-all cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/movies"
              className="px-5 py-2 text-sm font-medium rounded-lg bg-primary-500 text-background-950 hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              开始观影
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-100 transition-all cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-700/30 py-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-2.5 text-sm rounded-md transition-all ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/movies"
              className="block mx-4 mt-2 px-5 py-2.5 text-sm font-medium text-center rounded-lg bg-primary-500 text-background-950 hover:bg-primary-600 transition-all"
            >
              开始观影
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}